import { apiCall } from 'hooks/service';
import { instanceExternalUrl } from 'services/axios';

import { parseUrlFile } from './file';

export const UploadFile = async (file: File, nameFile: string) => {
  const type = file.type;

  const url: string = await apiCall({
    url: `/presigned-url`,
    method: 'POST',
    data: {
      fileName: nameFile,
      fileType: type ?? '',
    },
  });

  if (url) {
    await instanceExternalUrl.put(url, file, {
      headers: {
        'Content-Type': type,
        'x-amz-acl': 'public-read-write',
      },
    });

    return parseUrlFile(url);
  }

  return '';
};
